<div class="loadDistributed " *ngIf="loadingDistributed$()">
    <div class="tostes">
        <que-tost-display class="tost-item" *ngIf="!isTost"
            [tost]="{guid:'no-guid',message:{en:'In progress...',he:'הפעולה מתבצעת...'},position:tostPositionEnum.BottomLeft,seconds:30,type:tostTypeEnum.LOAD}"
            (removeTost)="removeTost()"></que-tost-display>
    </div>
</div>
<router-outlet></router-outlet>